<tt-form-field>
  <span #searchTermSpan class="tt-search_input" ttInput [class.tt-search_input--disabled]="disabled()" [clearable]="true" [noBorder]="true">
    <mat-icon ttInputPrefix [icon]="'search'" [iconSize]="16" />
    <input
      id="tt-search_input-element"
      [autocomplete]="'off'"
      [disabled]="disabled()"
      [ngModel]="searchTerm()"
      [placeholder]="(disabled() ? 'GuidelineSearch.Input.DisabledPlaceholder' : 'GuidelineSearch.Input.Placeholder') | transloco"
      (blur)="onInputBlur()"
      (focus)="onInputFocus()"
      (ngModelChange)="handleSearchTermChange($event)" />
  </span>
</tt-form-field>

<ng-template #resultDropdown let-data>
  <div class="tt-search_dropdown">
    <div class="tt-search_dropdown-tab-selector">
      @if (data.attachmentVm().data.length > 0 && !data.attachmentVm().loading && !data.guidelineVm().loading) {
        <div class="tt-search_dropdown-tab-selector-buttons">
          <button
            class="tt-search_dropdown-tab-selector-buttons-item"
            [class.tt-search_dropdown-tab-selector-buttons-item--active]="activeTab() === 'guidelines'"
            (click)="switchTab('guidelines')">
            {{ 'SearchDropdown.Tab.Guidelines' | transloco }}
            @if (data.guidelineVm().data.length > 0) {
              <span>({{ data.guidelineVm().paging.maxElements }})</span>
            }
          </button>
          <button
            class="tt-search_dropdown-tab-selector-buttons-item"
            [class.tt-search_dropdown-tab-selector-buttons-item--active]="activeTab() === 'attachments'"
            (click)="switchTab('attachments')">
            {{ 'SearchDropdown.Tab.Attachments' | transloco }} ({{ data.attachmentVm().data.length
            }}{{ data.attachmentVm().hasMore ? '+' : '' }})
          </button>
        </div>
      }
      <common-checkbox variant="primary" [ngModel]="isHomeFilterActive()" (ngModelChange)="onHomeFilterActiveChanged($event)">
        {{ 'GuidelineSearch.SearchInHomeOrganization' | transloco }}
      </common-checkbox>
    </div>

    <div class="tt-search_dropdown-tab">
      @switch (activeTab()) {
        @case ('guidelines') {
          <tt-guideline-search-result-list
            [hasMoreResults]="data.guidelineVm().hasMore"
            [loading]="data.guidelineVm().loading"
            [loadingMore]="data.guidelineVm().loadingMore"
            [searchResults]="data.guidelineVm().data"
            [searchTerm]="data.searchTerm()"
            (clearSearch)="onClearSearch()"
            (itemSelected)="onGuidelineSelected($event)"
            (loadNextPage)="onLoadMoreGuidelines()" />
        }
        @case ('attachments') {
          <tt-attachment-search-result-list
            [hasMoreResults]="data.attachmentVm().hasMore"
            [loading]="data.attachmentVm().loading"
            [loadingMore]="data.attachmentVm().loadingMore"
            [searchResults]="data.attachmentVm().data"
            [searchTerm]="data.searchTerm()"
            (clearSearch)="onClearSearch()"
            (itemSelected)="onAttachmentSelected($event)"
            (loadNextPage)="onLoadMoreAttachments()" />
        }
      }
    </div>
  </div>
</ng-template>
